import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import SurchargeInfo from './SurchargeInfo';
import * as orderActions from './../../../../../../actions/orderAction';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openModalDetail: () => dispatch(orderActions.openModalDetail()),
        closeModalDetail: () => dispatch(orderActions.closeModalDetail()),
        deleteSurchargeDetail: (surcharge) => dispatch(orderActions.deleteSurchargeDetail(surcharge))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SurchargeInfo));